import CheckmateSelect from '../CheckmateSelect';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { IQueryFilterCriteriaSelectionValue } from '../../../interfaces/IQuery';
import { useCaseManagersInZone } from '../../../shared/react-query-hooks/useCaseManagersInZone';
import { useMemo } from 'react';

export interface ILocalCounselSelectorProps {
    disabled?: boolean;
    multi?: boolean;
    onChange: (optionsList: any) => void;
    value: IQueryFilterCriteriaSelectionValue[] | undefined;
    validationError?: string | undefined;
}

export function CaseManagerSelector(props: ILocalCounselSelectorProps) {
    const { data, isLoading } = useCaseManagersInZone();

    const availableOptions = useMemo(
        () =>
            data?.map(
                (caseManager) =>
                    ({
                        label: `${caseManager.profile?.firstName} ${caseManager.profile?.lastName}`,
                        value: caseManager.guid,
                        guid: caseManager.guid,
                    } as IMultiSelectOption)
            ),
        [props.value, data]
    );

    const selectedOptions = useMemo(
        () => availableOptions?.filter((opt) => props.value?.map((v) => v.guid).includes(opt.guid)),
        [props.value, availableOptions]
    );

    return (
        <>
            <CheckmateSelect
                isMulti={props.multi}
                options={availableOptions ?? []}
                isDisabled={props.disabled}
                value={selectedOptions}
                onChange={props.onChange}
                isLoading={isLoading}
            />
            <span className="text-danger">{props.validationError}</span>
        </>
    );
}
